import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Crop, Loader2 } from 'lucide-react';
import { gymSocialAlertError, gymSocialAlertWarn, gymSocialBtnPrimary, gymSocialMutedText } from '../gymPageTheme';

export default function GymSocialStoryPreview({
  imageUrl,
  storyFit,
  onOpenCrop,
  cropping = false,
}) {
  const { t } = useTranslation();
  const [frameBroken, setFrameBroken] = useState(false);

  const borderClass =
    storyFit === 'bad'
      ? 'border-red-500 ring-2 ring-red-400/40'
      : storyFit === 'warn'
        ? 'border-amber-500 ring-2 ring-amber-400/30'
        : 'border-gray-800 dark:border-gray-900';

  const needsCrop = storyFit === 'warn' || storyFit === 'bad';

  return (
    <div className="w-full space-y-3">
      <div className="mx-auto w-full max-w-[220px]">
        <p className={`text-[10px] text-center mb-1 ${gymSocialMutedText}`}>
          {t('gym.social.posts.storyPreviewLabel')}
        </p>
        <div
          className={`w-full aspect-[9/16] rounded-[1.25rem] border-[6px] ${borderClass} overflow-hidden bg-black shadow-lg`}
        >
          {!frameBroken ? (
            <img
              src={imageUrl}
              alt=""
              className="w-full h-full object-cover"
              onError={() => setFrameBroken(true)}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-xs text-white/70 p-2 text-center">
              {t('gym.social.posts.storyPreviewError')}
            </div>
          )}
        </div>
      </div>

      <div className="w-full space-y-2">
        {storyFit === 'good' && (
          <p className="text-sm text-green-700 dark:text-green-300">{t('gym.social.posts.storyFitGood')}</p>
        )}
        {needsCrop && (
          <div className={storyFit === 'bad' ? gymSocialAlertError : gymSocialAlertWarn}>
            <p>
              {storyFit === 'bad'
                ? t('gym.social.posts.storyFitBad')
                : t('gym.social.posts.storyFitWarn')}
            </p>
          </div>
        )}
        <p className={`text-xs ${gymSocialMutedText}`}>{t('gym.social.posts.storySpecs')}</p>
        {needsCrop && onOpenCrop && (
          <button
            type="button"
            disabled={cropping}
            onClick={onOpenCrop}
            className={`${gymSocialBtnPrimary} w-full justify-center py-2.5 text-sm font-semibold`}
          >
            {cropping ? <Loader2 className="h-4 w-4 animate-spin" /> : <Crop className="h-4 w-4" />}
            {t('gym.social.posts.storyCrop916')}
          </button>
        )}
      </div>
    </div>
  );
}
